import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { jwtSchema } from '../../../schemas/jwt.schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Generate a JWT for a target Account
 * @param targetAccountId ID of the target Account
 * @returns Common JWT (with a null refresh_token)
 */
export function getIdentityTokenSwitchaccount(
  this: unknown,
  targetAccountId: number
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).identityTokenSwitchAccountUrl
      }/${encodeURIComponent(targetAccountId)}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(
    selectData(
      jwtSchema.extend({
        refresh_token: z.string().nullable(),
      })
    )
  );
}
